import { TwoUp } from '$components/layouts/twoUp'
import React from 'react'
import { MDXTag } from '@mdx-js/tag'

export default { TwoUp, React, MDXTag }